"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5158],{

/***/ 65750:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(11720));
const building_blocks_ui_common_1 = __webpack_require__(4005);
const building_blocks_ui_common_2 = __webpack_require__(4005);
const Container = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_2.Flex) `
  height: 100vh;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: white;
`;
const Wrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_2.Flex) `
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 60%;
`;
const Heading = building_blocks_ui_common_1.styled.div `
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  margin-top: 20px;
  text-align: center;

  @media (min-width: 768px) {
    color: #151619;
    font-weight: 700;
    font-size: 24px;
    line-height: 37px;
    margin-top: 20px;
  }
`;
const SubHeading = building_blocks_ui_common_1.styled.div `
  color: #5b5675;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
  text-align: center;

  @media (min-width: 768px) {
    color: #8990a1;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-top: 5px;
  }
`;
const IMG = building_blocks_ui_common_1.styled.img `
  @media (min-width: 768px) {
    height: 150px;
    width: 150px;
  }
`;
const Loader = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Container, null,
            react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(IMG, { src: "https://acko-home-prod.ackoassets.com/images/animationLoader.gif", alt: "Loading..." }),
                react_1.default.createElement(Heading, null, "Please wait, we're Fetching your vehicle details"),
                react_1.default.createElement(SubHeading, null, "It will take a few seconds")))));
};
exports["default"] = Loader;
//# sourceMappingURL=AnimatedLoader.js.map

/***/ }),

/***/ 69437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(11720));
const building_blocks_ui_common_1 = __webpack_require__(4005);
const building_blocks_ui_common_2 = __webpack_require__(4005);
const img_1 = __importDefault(__webpack_require__(97148));
const Container = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_2.Flex) `
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #ffffffab;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  opacity: 0.85;
`;
const Image = `
  width: 100px;
  height: 100px;
`;
function BasicLoader() {
    return (React.createElement(Container, null,
        React.createElement(img_1.default, { styles: Image })));
}
exports["default"] = BasicLoader;
//# sourceMappingURL=BasicLoader.js.map

/***/ }),

/***/ 97148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(11720));
const building_blocks_ui_common_1 = __webpack_require__(4005);
const f = () => ({
    __html: `<?xml version="1.0" encoding="UTF-8"?>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink= "http://www.w3.org/1999/xlink" preserveAspectRatio="none" viewBox="0 0 100 100" style="background-color:#FFFFFF00; overflow:visible">
      <title>Scene</title>
      <!-- Layers -->
      <!-- Layer: circle_1 -->
      <svg x="24" y="50.5" width="0.01" height="0.01" style ="overflow:visible" opacity="1" label="anchorPointContainer">
          <animate attributeName="y" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.333333;0.666667;1" repeatCount="indefinite" values="50.5;31.5;50.5;50.5"/>
          <g label="flipped" transform="scale(1 1)">
              <g label="layerRotation" transform="rotate(0)">
                  <svg x="-5.815" y="-5.815" width="11.63" height="11.63" style ="overflow:visible" opacity="1" label="circle_1Container">
                      <animate attributeName="x" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0.42 0 0.58 1;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.333333;0.666667;1" repeatCount="indefinite" values="-5.815;-7;-5.815;-5.815"/>
                      <animate attributeName="y" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.333333;0.666667;1" repeatCount="indefinite" values="-5.815;-7;-5.815;-5.815"/>
                      <animate attributeName="width" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0.42 0 0.58 1;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.333333;0.666667;1" repeatCount="indefinite" values="11.63;14;11.63;11.63"/>
                      <animate attributeName="height" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.333333;0.666667;1" repeatCount="indefinite" values="11.63;14;11.63;11.63"/>
                      <g clip-path="" label="maskPath">
                          <g label="layerShadow" filter="">
                          <path d="M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63" fill="#7C47E1" id="circle_1" stroke="#7C47E1" stroke-dasharray="0" stroke-dashoffset="0" stroke-miterlimit="10" stroke-width="0">
                              <animate attributeName="d" calcMode="spline" dur="0.9s" fill="freeze" href="#circle_1" keySplines="0.42 0 0.58 1;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.333333;0.666667;1" repeatCount="indefinite" values="M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63;M7,14c3.85,0,7,-3.15,7,-7 0,-3.85,-3.15,-7,-7,-7 -3.85,0,-7,3.15,-7,7 0,3.85,3.15,7,7,7zM7,14;M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63;M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63"/>
                          </path>
        
                          </g>
                      </g>
                  </svg>
              </g>
          </g>
      </svg>
  
      <!-- Layer: circle_2 -->
      <svg x="50" y="50.5" width="0.01" height="0.01" style ="overflow:visible" opacity="1" label="anchorPointContainer">
          <animate attributeName="y" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.166667;0.5;0.833333;1" repeatCount="indefinite" values="50.5;50.5;31.5;50.5;50.5"/>
          <g label="flipped" transform="scale(1 1)">
              <g label="layerRotation" transform="rotate(0)">
                  <svg x="-5.815" y="-5.815" width="11.63" height="11.63" style ="overflow:visible" opacity="1" label="circle_2Container">
                      <animate attributeName="x" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.166667;0.5;0.833333;1" repeatCount="indefinite" values="-5.815;-5.815;-7;-5.815;-5.815"/>
                      <animate attributeName="y" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.166667;0.5;0.833333;1" repeatCount="indefinite" values="-5.815;-5.815;-7;-5.815;-5.815"/>
                      <animate attributeName="width" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.166667;0.5;0.833333;1" repeatCount="indefinite" values="11.63;11.63;14;11.63;11.63"/>
                      <animate attributeName="height" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.166667;0.5;0.833333;1" repeatCount="indefinite" values="11.63;11.63;14;11.63;11.63"/>
                      <g clip-path="" label="maskPath">
                          <g label="layerShadow" filter="">
                          <path d="M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63" fill="#7C47E1" id="circle_2" stroke="#7C47E1" stroke-dasharray="0" stroke-dashoffset="0" stroke-miterlimit="10" stroke-width="0">
                              <animate attributeName="d" calcMode="spline" dur="0.9s" fill="freeze" href="#circle_2" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95;0.42 0 0.58 1" keyTimes="0;0.166667;0.5;0.833333;1" repeatCount="indefinite" values="M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63;M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63;M7,14c3.85,0,7,-3.15,7,-7 0,-3.85,-3.15,-7,-7,-7 -3.85,0,-7,3.15,-7,7 0,3.85,3.15,7,7,7zM7,14;M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63;M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63"/>
                          </path>
        
                          </g>
                      </g>
                  </svg>
              </g>
          </g>
      </svg>
  
      <!-- Layer: circle_3 -->
      <svg x="76" y="50.5" width="0.01" height="0.01" style ="overflow:visible" opacity="1" label="anchorPointContainer">
          <animate attributeName="y" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95" keyTimes="0;0.355556;0.688889;1" repeatCount="indefinite" values="50.5;50.5;31.5;50.23"/>
          <g label="flipped" transform="scale(1 1)">
              <g label="layerRotation" transform="rotate(0)">
                  <svg x="-5.815" y="-5.815" width="11.63" height="11.63" style ="overflow:visible" opacity="1" label="circle_3Container">
                      <animate attributeName="x" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95" keyTimes="0;0.355556;0.688889;1" repeatCount="indefinite" values="-5.815;-5.815;-7;-5.83"/>
                      <animate attributeName="y" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95" keyTimes="0;0.355556;0.688889;1" repeatCount="indefinite" values="-5.815;-5.815;-7;-5.83"/>
                      <animate attributeName="width" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95" keyTimes="0;0.355556;0.688889;1" repeatCount="indefinite" values="11.63;11.63;14;11.66"/>
                      <animate attributeName="height" calcMode="spline" dur="0.9s" fill="freeze" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95" keyTimes="0;0.355556;0.688889;1" repeatCount="indefinite" values="11.63;11.63;14;11.66"/>
                      <g clip-path="" label="maskPath">
                          <g label="layerShadow" filter="">
                          <path d="M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63" fill="#7C47E1" id="circle_3" stroke="#7C47E1" stroke-dasharray="0" stroke-dashoffset="0" stroke-miterlimit="10" stroke-width="0">
                              <animate attributeName="d" calcMode="spline" dur="0.9s" fill="freeze" href="#circle_3" keySplines="0 0 1 1;0.445 0.05 0.55 0.95;0.445 0.05 0.55 0.95" keyTimes="0;0.355556;0.688889;1" repeatCount="indefinite" values="M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63;M5.815,11.63c3.198,0,5.815,-2.617,5.815,-5.815 0,-3.198,-2.617,-5.815,-5.815,-5.815 -3.198,0,-5.815,2.617,-5.815,5.815 0,3.198,2.617,5.815,5.815,5.815zM5.815,11.63;M7,14c3.85,0,7,-3.15,7,-7 0,-3.85,-3.15,-7,-7,-7 -3.85,0,-7,3.15,-7,7 0,3.85,3.15,7,7,7zM7,14;M5.83,11.66c3.207,0,5.83,-2.624,5.83,-5.83 0,-3.207,-2.624,-5.83,-5.83,-5.83 -3.207,0,-5.83,2.624,-5.83,5.83 0,3.207,2.624,5.83,5.83,5.83zM5.83,11.66"/>
                          </path>
        
                          </g>
                      </g>
                  </svg>
              </g>
          </g>
      </svg>
  
  
  </svg>`
});
const StyledSpan = building_blocks_ui_common_1.styled.span `
  ${(props) => props.styles}
`;
const Img = ({ styles }) => {
    return React.createElement(StyledSpan, { styles: styles, dangerouslySetInnerHTML: f() });
};
exports["default"] = Img;
//# sourceMappingURL=img.js.map

/***/ }),

/***/ 55158:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AnimatedLoader = exports.BasicLoader = void 0;
var BasicLoader_1 = __webpack_require__(69437);
Object.defineProperty(exports, "BasicLoader", ({ enumerable: true, get: function () { return __importDefault(BasicLoader_1).default; } }));
var AnimatedLoader_1 = __webpack_require__(65750);
Object.defineProperty(exports, "AnimatedLoader", ({ enumerable: true, get: function () { return __importDefault(AnimatedLoader_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styled = void 0;
__exportStar(__webpack_require__(57476), exports);
__exportStar(__webpack_require__(17726), exports);
__exportStar(__webpack_require__(35595), exports);
var styled_components_1 = __webpack_require__(57476);
Object.defineProperty(exports, "styled", ({ enumerable: true, get: function () { return __importDefault(styled_components_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 57476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ServerStyleSheet = exports.styledComponents = exports.ThemeProvider = exports.keyframes = exports.createGlobalStyle = exports.css = void 0;
//@ts-nocheck
const styledComponents = __importStar(__webpack_require__(10063));
exports.styledComponents = styledComponents;
const { default: styled, css, createGlobalStyle, keyframes, ThemeProvider, ServerStyleSheet, } = styledComponents;
exports.css = css;
exports.createGlobalStyle = createGlobalStyle;
exports.keyframes = keyframes;
exports.ThemeProvider = ThemeProvider;
exports.ServerStyleSheet = ServerStyleSheet;
const Styled = styled;
exports["default"] = Styled;
//# sourceMappingURL=styled-components.js.map

/***/ }),

/***/ 17726:
/***/ (function(__unused_webpack_module, exports) {


/**
<<<<<<< HEAD
* ======================
* Break Points
* ======================
*/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.$fontWeightBolder = exports.$fontWeightBold = exports.$fontWeightNormal = exports.$fontWeightLight = exports.$primaryColorsGreen = exports.$fontSize = exports.$space = exports.$blackShades = exports.$greyShades = exports.$greenShades = exports.$backgroundColor = exports.$white = exports.$grayLighter = exports.$grayLight = exports.$hyperlink = exports.$error = exports.$info = exports.$warning = exports.$neutralColors = exports.$accentColors = exports.$primaryColors = exports.$fontFamily = exports.$containerXsL = exports.$screenL = exports.$screenXsL = exports.$screenXs = exports.$containerXs = exports.$gutter = void 0;
exports.$gutter = 16;
exports.$containerXs = '28.125em';
exports.$screenXs = '30em';
exports.$screenXsL = '40em';
exports.$screenL = '48em';
exports.$containerXsL = '38.125em';
/**
 * ==========
 * Font family
 * ==========
 */
exports.$fontFamily = "'Inter', 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";
/**
 * ==========
 * Colors
 * ==========
 */
exports.$primaryColors = {
    lightest: '#DDD4F8',
    light: '#9174E7',
    normal: '#582CDB',
    dark: '#421EAE',
};
exports.$accentColors = {
    lightest: '#D4F7E6',
    light: '#7EE7B4',
    normal: '#44CB86',
    dark: '#1FAD69',
};
exports.$neutralColors = {
    lightest: '#DCDCE0',
    light: '#8D8E99',
    normal: '#5C5D66',
    dark: '#151619',
};
exports.$warning = '#FF9100';
exports.$info = '#697890';
exports.$error = '#FD4B44';
exports.$hyperlink = '#3C8CEA';
exports.$grayLight = '#F3F3F7';
exports.$grayLighter = '#F3F7FF';
exports.$white = '#FFFFFF';
exports.$backgroundColor = exports.$grayLight;
exports.$greenShades = {
    normal: '#37C87E',
    dark: '#00A871',
};
exports.$greyShades = {
    normal: '#C8D0DB',
};
exports.$blackShades = {
    normal: '#434F5A',
    dark: '#282E33',
};
/**
 * ==========
 * Spacing
 * ==========
 */
exports.$space = {
    xs: '0.5em',
    s: '1em',
    sm: '1.5em',
    m: '2em',
    l: '3em',
    xl: '4em',
    xxl: '6em',
};
/**
 * ==========
 * font
 * ==========
 */
exports.$fontSize = {
    xxxs: '0.625rem',
    xxs: '0.75rem',
    xs: '0.875rem',
    normal: '1rem',
    small: '1.125rem',
    medium: '1.25rem',
    large: '1.5rem',
    xl: '1.875rem',
    xxl: '2.375rem',
    xxxl: '2.875rem', // 46px
};
exports.$primaryColorsGreen = {
    disabled: '#E5E5E5',
    lightest: '#f2faf7',
    light: '#0FA457',
    normal: '#0FA457',
    dark: '#149452',
};
/**
 * ==========
 * Font weights
 * ==========
 */
exports.$fontWeightLight = 400;
exports.$fontWeightNormal = 500;
exports.$fontWeightBold = 600;
exports.$fontWeightBolder = 700;
exports["default"] = {};
//# sourceMappingURL=theme.js.map

/***/ }),

/***/ 35595:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Flex = exports.Box = void 0;
const styled_components_1 = __importDefault(__webpack_require__(10063));
exports.Box = styled_components_1.default.div `
  width: ${props => (props.width ? props.width : "100%")};
  ${props => props.justifyContent ? `justify-content: ${props.justifyContent}` : ""};
  ${props => (props.alignItems ? `align-items: ${props.alignItems}` : "")};
  ${props => (props.textAlign ? `text-align: ${props.textAlign}` : "")};
  ${props => (props.margin ? `margin: ${props.margin}` : "")};
  ${props => (props.padding ? `padding: ${props.padding}` : "")};
  ${props => (props.mt ? `margin-top: ${props.mt}` : "")};
  ${props => (props.mr ? `margin-right: ${props.mr}` : "")};
  ${props => (props.mb ? `margin-bottom: ${props.mb}` : "")};
  ${props => (props.ml ? `margin-left: ${props.ml}` : "")};
  ${props => (props.pt ? `padding-top: ${props.pt}` : "")};
  ${props => (props.pb ? `padding-bottom: ${props.pb}` : "")};
  ${props => (props.pl ? `padding-left: ${props.pl}` : "")};
  ${props => (props.pr ? `padding-right: ${props.pr}` : "")};
  ${props => (props.overflow ? `overflow: ${props.overflow}` : "")};
  ${props => props.styles};
`;
exports.Flex = (0, styled_components_1.default)(exports.Box) `
  display: flex;
  ${props => props.flexDirection ? `flex-direction: ${props.flexDirection}` : ""};
  ${props => props.styles};
`;
exports["default"] = {};
//# sourceMappingURL=util.js.map

/***/ })

}]);